function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M3.6602,21.7 C3.2917,21.7 3,21.4226 3,21.0721 C3,17.7721 5.825,15.1 9.2794,15.1 L15.671,15.1 C19.1254,15.1 21.9504,17.7721 21.9504,21.0721 C21.9504,21.4226 21.6587,21.7 21.2902,21.7 L21.2902,21.7 L3.6602,21.7 Z M12.35,12.9 C9.6169,12.9 7.4,10.6645 7.4,7.9424 C7.4,5.2203 9.6169,3 12.35,3 C15.0831,3 17.3,5.2051 17.3,7.9424 C17.3,10.6797 15.0831,12.9 12.35,12.9 L12.35,12.9 Z"
});
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.3a9b290efd4f6e3c952b49dc0a1b2350.svg";
export { ForwardRef as ReactComponent };